<ng-container [formGroup]="contactForm">
    <h3 class="form-header" mat-dialog-titlei18n>Link Point of Contact</h3>

    <div class="grid" style="margin-left: 20px;">

        <div class="row">
            <div fxFlex="50">
                <!-- <tsl-form-field fxFlex="90"> -->
                <div class="tds-form-item tds-form-item--choice">
                    <input type="radio" formControlName="contactType" name="contactType" id="radiochoice1"
                        class="tds-form-input" value="old" />
                    <!-- <div class="tds-form-label-wrap"> -->
                    <label for="radiochoice1" class="tds-form-label">
                        <span class="tds-form-label-text" i18n-title title="Link Existing Contacts shown from your organizations Profile Contact Tab">Link Existing Contact</span>
                    </label>
                    <!-- </div> -->
                </div>
                <!-- </tsl-form-field> -->
            </div>

            <div fxFlex="50">
                <!-- <tsl-form-field fxFlex="90"> -->
                <div class="tds-form-item tds-form-item--choice">
                    <input type="radio" formControlName="contactType" name="contactType" id="radiochoice2"
                        class="tds-form-input" value="new" />
                    <!-- <div class="tds-form-label-wrap"> -->
                    <label for="radiochoice" class="tds-form-label">
                        <span class="tds-form-label-text" i18n-title title="Add a New Point of Contact for Ship From Address Use">Add a New Point of Contact</span>
                    </label>
                    <!-- </div> -->
                </div>
                <!-- </tsl-form-field> -->
            </div>
        </div>
        <div style="margin-top: 20px;">
            <ng-container *ngIf="ContactFormControls.contactType.value ==='old'">
                <div class="row">
                    <div fxFlex="50">
                        <tsl-select formControlName="contacts" multiple>
                            <tsl-option *ngFor="let option of contactList" [value]="option">
                               <span> {{ option.getFullName()}}, {{ option.phone}}, {{ option.email}}</span> 
                            </tsl-option>
                        </tsl-select>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="ContactFormControls.contactType.value ==='new'">
                <div class="row">
                    <div fxFlex="50">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@c83b838d845690bcb897f775f53b5316535306dc" t="c83b838d845690bcb897f775f53b5316535306dc">First Name</tsl-label>
                            <input tslInput fullWidth maxlength="30" formControlName="fname" name="fname" />
                            <tsl-hint align="below" class="max-length-hint">{{contactForm.get('fname').value?.length ||
                                0}}/
                                30</tsl-hint>
                            <tsl-error
                                *ngIf="ContactFormControls.fname.errors && (ContactFormControls.fname.dirty || ContactFormControls.fname.touched) && ContactFormControls.fname.errors.whitespace">
                                <span i18n="@@14e192cb676257db8fed3dad864f5e5f8a17e119" t="14e192cb676257db8fed3dad864f5e5f8a17e119">First Name is Required</span>
                            </tsl-error>
                            <tsl-error
                                *ngIf="ContactFormControls.fname.errors && !ContactFormControls.fname.errors.required && ContactFormControls.fname.errors.pattern">
                                <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54" t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters allowed</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>

                    <div fxFlex="50">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@166b2cc65003221ff5f3ec05d5baca41e6821396" t="166b2cc65003221ff5f3ec05d5baca41e6821396">Last Name</tsl-label>
                            <input tslInput fullWidth maxlength="30" formControlName="lname" name="lname" />
                            <tsl-hint align="below" class="max-length-hint">{{contactForm.get('lname').value?.length ||
                                0}} /
                                30</tsl-hint>
                            <tsl-error
                                *ngIf="ContactFormControls.lname.errors && (ContactFormControls.lname.dirty || ContactFormControls.lname.touched) && ContactFormControls.lname.errors.whitespace">
                                <span i18n="@@3da6a76bc3eaba500cadef813d5bb7fa09e7e9eb" t="3da6a76bc3eaba500cadef813d5bb7fa09e7e9eb">Last name is Required </span>
                            </tsl-error>
                            <tsl-error
                                *ngIf="ContactFormControls.lname.errors && !ContactFormControls.lname.errors.required && ContactFormControls.lname.errors.pattern">
                                <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54" t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters allowed</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>
                </div>

                <div class="row">
                    <div fxFlex="50">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@244aae9346da82b0922506c2d2581373a15641cc" t="244aae9346da82b0922506c2d2581373a15641cc">Email</tsl-label>
                            <input id="email" tslInput type="text" fullWidth maxlength="256" formControlName="email" />
                            <tsl-hint align="below" class="max-length-hint">{{contactForm.get('email').value?.length ||
                                0}}
                                / 256
                            </tsl-hint>
                            <tsl-error
                                *ngIf="ContactFormControls.email.errors && ContactFormControls.email.errors.required && (ContactFormControls.email.dirty || ContactFormControls.email.touched)">
                                <span i18n="@@d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71" t="d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71">Email is Required </span>
                            </tsl-error>
                            <tsl-error *ngIf="ContactFormControls.email.errors && ContactFormControls.email.errors.email">
                                <span i18n="@@e5d28518a74d03d6ba089a7046ea9e38fbc026e4" t="e5d28518a74d03d6ba089a7046ea9e38fbc026e4">Enter a valid email </span>
                              </tsl-error>
                        </tsl-form-field>
                    </div>
                    <div fxFlex="50">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@7ef67f76ab81c082a91782412af3639cca2126de" t="7ef67f76ab81c082a91782412af3639cca2126de">Mobile</tsl-label>
                            <input id="mobile" tslInput fullWidth maxlength="30" formControlName="mobile" />
                            <tsl-hint align="below" class="max-length-hint">{{contactForm.get('mobile').value?.length ||
                                0}}
                                / 30
                            </tsl-hint>
                            <tsl-error
                                *ngIf="ContactFormControls.mobile.errors && (ContactFormControls.mobile.dirty || ContactFormControls.mobile.touched) && ContactFormControls.mobile.errors.whitespace">
                                <span i18n="@@4448605949050849541" t="4448605949050849541">mobile is Required </span>
                            </tsl-error>
                            <mat-hint></mat-hint>
                        </tsl-form-field>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>



    <br>

    <!-- Action Buttons -->
    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">Cancel</button>
        <button tsl-button size="small" color="blue" filled  (click)="save()"
            i18n="@@e03b6cba7c88318e4f91a60a079870e8fba4bee7" t="e03b6cba7c88318e4f91a60a079870e8fba4bee7">Link</button>
    </div>
</ng-container>